<template>
	<div class="w-full flex flex-wrap px-6 lg:px-0 py-10 lg:py-16">

		<div class="w-full lg:w-5/12">
			<div class="border-t border-black ">
				<div
						class="border-b border-black"
						v-for="(update, index) in updates" :key="index+'up'">
					<div @click="setActive(index)" class="flex items-start py-5 mb-2 cursor-pointer">
						<div class="ml-3">
							<h6 class="uppercase ">{{ update.heading }}</h6>
							<span>{{ parseDate(update.date.date) }}</span>
						</div>
						<svg
								class="ml-auto mr-3 transform"
								:class="active === index ?'rotate-90':'rotate-0'"
								width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2.18538 4.99338L-5.34058e-05 -4.26112e-07L9.74829 4.99338L-5.38429e-05 10L2.18538 4.99338Z" fill="#000000"/>
						</svg>
					</div>
					<div
							:class="active === index ?'max-h-96 pb-4':'max-h-0'"
							class="overflow-hidden ease-linear transition-all duration-500 ml-3"
							v-html="update.content"></div>
				</div>
			</div>
		</div>
		<div class="w-full lg:w-7/12 lg:pl-8 order-first lg:order-last">
			<img :src="updates[active>=0?active:0].image" class="ml-auto mb-14 w-full lg:mb-0" />
		</div>
	</div>
</template>

<script>
import moment from "moment"
export default {
	name: "construction-updates",
	props: {
		updates: {
			type: Array,
			default: () => []
		},
	},
	data() {
		return {
			active: 0
		}
	},
	methods:{
		parseDate(date){
			return moment(date).format('MMMM Do, YYYY');
		},
		setActive(index){
			if(this.active === index){
				this.active = -1;
				return;
			}
			this.active = index;
		}
	}
}
</script>

<style scoped>

</style>
